module.exports = __webpack_public_path__ + "assets/normal/images/logo-white.3cef0242.png";